import { useRouter } from 'next/router';
import Head from 'next/head';
import _get from 'lodash/get';
import { useQuery } from '@apollo/client';
import { Formik, Form } from 'formik';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/styles';
import Loading from '../../../../components/loading';
import ErrorMessage from '../../../../components/error-message';
import NotFound from '../../../../components/not-found';
import { groupSubscribeQuery } from '../../../../apollo/groups';
import { buildTitle } from '../../../../utils/layout';
import GroupHeader from '../../../../components/groups/header';
import Main from '../../../../components/main';
import { useAppContext } from '../../../../contexts/app';
import CalendarLinks from '../../../../components/calendar-links';
import RadioGroupField from '../../../../components/forms/radio-group-field';
import MaterialLink from '../../../../components/material-link';

const useStyles = makeStyles((theme) => ({
  divider: {
    margin: theme.spacing(3, 0),
  },
}));

const GroupCalendarSubscribePage = () => {
  const router = useRouter();
  const { query } = router;
  const { isLoggedIn } = useAppContext();
  const classes = useStyles();

  const { data, loading, error } = useQuery(groupSubscribeQuery, {
    variables: {
      slug: query.slug,
    },
  });
  const group = _get(data, 'group');

  if (loading) { return <Loading />; }
  if (error) {
    return <ErrorMessage message='An error occurred while loading group.' error={error} />;
  }
  if (!group || group.found) { return <NotFound />; }

  return (
    <Main>
      <Head>
        <title>{buildTitle(`Subscribe to Calendar - ${group.name}`)}</title>
        <meta name="robots" content="noindex" />
      </Head>

      <GroupHeader group={group} tab="calendar" />

      <Typography variant="h2">Subscribe to Calendar</Typography>

      <Formik
        initialValues={{
          calendarType: group.membership ? 'member' : 'public',
        }}
      >
        {({ values }) => {
          const path = values.calendarType === 'member' ?
            `/groups/${group.slug}/calendar.ics?token=${group.membership.calendarToken}` :
            `/groups/${group.slug}/calendar.ics`;
          return (
            <Form>
              {isLoggedIn && (
                <RadioGroupField
                  name="calendarType"
                  label="Include in Calendar Feed"
                  options={[
                    { value: 'public', label: `${group.name} – Public Events Only` },
                    { value: 'member', label: `${group.name} – Public Events and Group Member Events` },
                  ]}
                />
              )}
              <p>Calendar links below include {group.name} public events{values.calendarType && ' and group member events'}.</p>
              <CalendarLinks path={path} />
            </Form>
          );
        }}
      </Formik>

      <Divider className={classes.divider} />

      <p>The above links are for this group only. <MaterialLink href="/calendar/subscribe">Subscribe to the full calendar</MaterialLink></p>
    </Main>
  );
};

export default GroupCalendarSubscribePage;
